<h1 mat-dialog-title style="text-align: center;">Take Selfie</h1>
<mat-dialog-content>
  <p>Take a selfie for this job. It will be saved to the rater form.</p>
  <p style="color: #757575; font-size: 0.9em;">
    {{ data.job.street_address }} - {{ data.job.customer_jobtype }}
  </p>

  <input type="file" accept="image/*" capture="user" id="selfie_prompt_input"
    style="display: none;" (change)="onFilePicked($event)" />

  <div *ngIf="!uploadedUrl" style="text-align: center; padding: 1em 0;">
    <button mat-flat-button color="primary" (click)="openCamera()" [disabled]="uploading">
      <fa-icon [icon]="facamera"></fa-icon>&nbsp; Take Picture
    </button>
  </div>

  <div *ngIf="uploading" style="padding: 0.5em 0;">
    <p style="margin: 0 0 0.25em 0;">Uploading... {{ percent }}%</p>
    <mat-progress-bar mode="determinate" [value]="percent"></mat-progress-bar>
  </div>

  <p *ngIf="errorText" style="color: #d32f2f;">{{ errorText }}</p>

  <div *ngIf="uploadedUrl" style="text-align: center;">
    <img [src]="uploadedUrl" alt="selfie" style="max-width: 100%; max-height: 50vh; border-radius: 6px;" />
    <p>Selfie saved to the rater form.</p>
  </div>
</mat-dialog-content>
<div mat-dialog-actions style="display: flex; flex-direction: row-reverse;">
  <button mat-button (click)="close()" [disabled]="uploading">{{ uploadedUrl ? 'Done' : 'Cancel' }}</button>
</div>
